import { useFeature } from '../features/features.hooks';

export const useIsLuxuryTheme = () => useFeature('luxury-rebrand', { isSiteWide: true });

export const useIsLuxuryTypography = () => useFeature('luxury-typography', { isSiteWide: true });

export const useIsLuxuryHeader = () => useFeature('luxury-header', { isSiteWide: true });
